// File:

import React from 'react';

const Organigrames = () => {
  return (
    <div>
      <h1>Organigrames</h1>
      <p>Bienvenue dans la section des Organigrames.</p>
    </div>
  );
}

export default Organigrames;
